
import {
  ON_SHOW_LOADER,
  CANTINA_LISTA_ESCOLAS_SUCESSO,
  CANTINA_LISTA_ESCOLAS,
  INICIO_CANTINA_FALHA,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  INICIO_CANTINA,
  INICIO_CANTINA_SUCESSO,
  BUSCAR_REGISTRO_CANTINA_IDADE,
  BUSCAR_REGISTRO_CANTINA_TURMA,
  BUSCAR_REGISTRO_CANTINA_TURMA_SUCESSO,
  BUSCAR_REGISTRO_CANTINA_IDADE_SUCESSO,
  BUSCAR_REGISTRO_RESTRICOES,
  BUSCAR_REGISTRO_RESTRICOES_SUCESSO,
  SETAR_COMBO_ESCOLA_CANTINA
} from 'constants/ActionTypes';

export const iniciaCantina = (token) => {
  return {
    type: INICIO_CANTINA,
    payload: token
  }
}

export const iniciaCantinaSucesso = (bearer)=> {
  return {
    type: INICIO_CANTINA_SUCESSO,
    payload:  bearer
  }
};

export const iniciaCantinaFalha =()=> {
  return {
    type: INICIO_CANTINA_FALHA,
  }
};


export const cantinaPorIdadeSucesso = (cantinaIdade) => {
  return {
    type: BUSCAR_REGISTRO_CANTINA_IDADE_SUCESSO,
    payload: cantinaIdade
  }
}

export const cantinaPorTurmaSucesso = (cantinaTurma) => {
  return {
    type: BUSCAR_REGISTRO_CANTINA_TURMA_SUCESSO,
    payload: cantinaTurma
  }
}

export const cantinaPorIdade = (payload) => {
  return {
    type: BUSCAR_REGISTRO_CANTINA_IDADE,
    payload
  }
}

export const cantinaPorTurma = (payload) => {
  return {
    type: BUSCAR_REGISTRO_CANTINA_TURMA,
    payload
  }
}

export const listaEscolas = () => {
  return {
    type: CANTINA_LISTA_ESCOLAS
  };
};

export const cantinaObterRestricoes = (payload) => {
  return {
    type: BUSCAR_REGISTRO_RESTRICOES,
    payload
  }
}
export const setCombo = (payload) =>
{
  return {
    type: SETAR_COMBO_ESCOLA_CANTINA,
    payload: payload
  }
}
export const cantinaObterRestricoesSucesso = (restricoes) => {
  return {
    type: BUSCAR_REGISTRO_RESTRICOES_SUCESSO,
    payload: restricoes
  }
}

export const listaEscolasSucesso = (escolas) => {
  return {
    type: CANTINA_LISTA_ESCOLAS_SUCESSO,
    payload: escolas
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};